import { Route } from '@angular/router';
import { shellRoutes } from '@wayout-admin/shell';

export const appRoutes: Route[] = [
	{
		path: '',
		children: shellRoutes,
	},
];
